import { isNil } from 'ramda';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

interface UseDataGridStatsTranslationProps {
  rowCount?: Union.Nullable<number>;
  filterCount?: Union.Nullable<number>;
}

export const useDataGridStatsTranslation = (props: UseDataGridStatsTranslationProps): string => {
  const { t } = useTranslation(undefined, { keyPrefix: 'DataGrid' });
  if (!isNil(props.filterCount) && !isNil(props.rowCount)) {
    return t('queryStats', { rowCount: props.rowCount, filterCount: props.filterCount });
  } else if (!isNil(props.filterCount)) {
    return t('queryFilter', { count: props.filterCount });
  } else if (!isNil(props.rowCount)) {
    return t('queryResults', { count: props.rowCount });
  }
  return '';
};
